import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    status: 'hide',
    message: null
  },
  reducers: {
    hideAlert (state) {
      state.status = 'hide';
      state.message = null;
    },
    alertWaiting (state, action) {
      state.status = 'waiting';
      state.message = action.payload || 'Submiting data, please wait a moment..';
    },
    alertSuccess (state, action) {
      state.status = 'success';
      state.message = action.payload || 'Submit data success!';
    },
    alertError (state, action) {
      state.status = 'error';
      state.message = action.payload || 'Submit error, please try again!';
    }
  }
})

export const { hideAlert, alertWaiting, alertSuccess, alertError } = alertSlice.actions
export default alertSlice.reducer
